import { render, staticRenderFns } from "./pending_payment.vue?vue&type=template&id=707a2d75&scoped=true&"
import script from "./pending_payment.vue?vue&type=script&lang=js&"
export * from "./pending_payment.vue?vue&type=script&lang=js&"
import style0 from "./pending_payment.vue?vue&type=style&index=0&id=707a2d75&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707a2d75",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default})
